import { Component } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, UserActivityStatus } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-request-history-grid',
    templateUrl: './request-history-grid.component.html',
    styleUrls: ['./request-history-grid.component.scss']
})
export class RequestHistoryGridComponent extends BaseGridComponent<UserActivityStatus, BaseState> {

    constructor(A: ServiceBagService) {
        super(A, 'RequestHistoryGridComponent', UserActivityStatus, BaseState);
    }

    OnRowClick(e) {
        if (e.data.EntryID) { this.Navigate(['/pages/general/request-history', e.data.EntryID]); }
    }

    GetStatusColor(isSuccess: boolean) {
        return isSuccess ? 'green-cyan' : 'cinnabar';
    }
}
